
<template>
  <div class="tab-area">

    <div class="tab-heading">

      <div class="tab" @click="handleTab(1)" :class="{active: tab === 1}">
        <i class="material-icons blue">language</i>

        <div class="text">Complex color technology</div>
      </div>

      <div class="tab" @click="handleTab(2)" :class="{active: tab === 2}">
        <i class="material-icons blue">language</i>

        <div class="text">Always-learning color A.I.</div>
      </div>

      <div class="tab" @click="handleTab(3)" :class="{active: tab === 3}">
        <i class="material-icons blue">language</i>

        <div class="text">Handcrafted by top designers</div>
      </div>

      <div class="tab" @click="handleTab(4)" :class="{active: tab === 4}">
        <i class="material-icons blue">language</i>

        <div class="text">Patent-protected processes</div>
      </div>

    </div>

    <div class="tab-content" ref="content">

      <div class="tab" v-show="tab === 1">
        <img src="https://colorful-assets.s3-us-west-2.amazonaws.com/colorful-frontend/api/1/advanced-tech_colorful.gif" alt=""/>
      </div>

      <div class="tab" v-show="tab === 2">
        <img src="https://colorful-assets.s3-us-west-2.amazonaws.com/colorful-frontend/api/1/always-learning.gif" alt=""/>
      </div>

      <div class="tab" v-show="tab === 3">
        <img src="https://colorful-assets.s3-us-west-2.amazonaws.com/colorful-frontend/api/1/designers_colorful.gif" alt=""/>
      </div>

      <div class="tab" v-show="tab === 4">
        <img src="https://colorful-assets.s3-us-west-2.amazonaws.com/colorful-frontend/api/1/patented_colorful.gif" alt=""/>
      </div>

    </div>

    <div class="dots visible-phone">
      <div class="dot" @click="handleTab(1)" :class="{active: tab === 1}"></div>

      <div class="dot" @click="handleTab(2)" :class="{active: tab === 2}"></div>

      <div class="dot" @click="handleTab(3)" :class="{active: tab === 3}"></div>

      <div class="dot" @click="handleTab(4)" :class="{active: tab === 4}"></div>
    </div>

  </div>
</template>

<script>
import tab from '../home/homeTab';

export default {
  name: 'api-partner-tab',
  ...tab,
};
</script>

<style lang="scss" scoped>
  @import '../../styles/_home';
</style>
